import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ReportTableType } from 'components/ReportsTables/ReportTableType';

export interface ReportPageState {
  currentReportTable: ReportTableType;
}

export const initialState: ReportPageState = {
  currentReportTable: ReportTableType.MCTMonitoring,
};

const reportPageSlice = createSlice({
  name: 'Reports',
  initialState,
  reducers: {
    setCurrentReportTable(state, action: PayloadAction<ReportTableType>) {
      state.currentReportTable = action.payload;
    },
  },
});

export const { setCurrentReportTable } = reportPageSlice.actions;

export default reportPageSlice.reducer;
